"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorListener = void 0;
var tslib_1 = require("tslib");
var renderer_class_names_1 = require("../../../core/canvas/renderer-class-names");
var frame_base_listener_1 = require("./frame-base-listener");
var AnchorListener = (function (_super) {
    tslib_1.__extends(AnchorListener, _super);
    function AnchorListener(rendererCache, stringResources, readOnlyPropertyHolder, fieldOptions) {
        var _this = _super.call(this, rendererCache, stringResources, fieldOptions) || this;
        _this.readOnlyPropertyHolder = readOnlyPropertyHolder;
        return _this;
    }
    AnchorListener.prototype.baseFrameClassName = function () {
        return renderer_class_names_1.RendererClassNames.ANCHOR;
    };
    AnchorListener.prototype.NotifyShow = function (pageIndex, bounds, tip, isTextBox, isAnchoredObject, rotation) {
        if (this.readOnlyPropertyHolder.isReadOnlyPersistent)
            _super.prototype.NotifyHide.call(this);
        else
            _super.prototype.NotifyShow.call(this, pageIndex, bounds, tip, isTextBox, isAnchoredObject, rotation);
    };
    return AnchorListener;
}(frame_base_listener_1.FrameBaseListener));
exports.AnchorListener = AnchorListener;
